import localConf from '@/local-conf';

export default {
  fetchUpload: (filePath: string): Promise<string> => {
    return new Promise((reslove, reject) => {
      return uni.uploadFile({
        url: `${localConf.host}/MinioController/updateFile`,
        filePath,
        name: 'file',
        success: (res) => {
          return reslove(res.data);
        },
        fail: (err) => {
          console.log(err);
          return reject(err);
        },
      });
    });
  },
  fetchForumUpload: (filePath: string): Promise<string> => {
    return new Promise((reslove, reject) => {
      return uni.uploadFile({
        url: `${localConf.host}/MinioController/forumUpdateFile`,
        filePath,
        name: 'file',
        success: (res) => {
          return reslove(res.data);
        },
        fail: (err) => {
          console.log(err);
          return reject(err);
        },
      });
    });
  },
};
